// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, tooltip: false }\"></div> <lookup-config field=\"field\" all-fields=\"allFields\" add-look-up-current-actor-option=\"true\"></lookup-config> ";
// Exports
export default code;